export default [
	{
		slot: 'morning',
		value: 'morning'
	},
	{
		slot: 'afternoon',
		value: 'afternoon'
	},
	{
		slot: 'evening',
		value: 'evening'
	}
]
